import React from 'react';

const Disclaimer = (props) => {
    const { colors, microsite_clt } = props;
    console.log("colors", colors);
    // Get disclaimer content from props or use default
    const disclaimerText = microsite_clt?.custom_disclamer || '';


    const customNoteText = microsite_clt?.custom_note || '';


    return (
        <>
            {microsite_clt?.registration_name_at_new_microsite_footer === 1 && (
                <div className="mx-auto w-[80%] max-sm:w-[95%]" style={{ backgroundColor: colors?.primary || '#2167A7' }}>
                    <p className="text-center text-white py-2 px-4">
                        {(microsite_clt?.registration_name || microsite_clt?.registration_number) && (
                            <span className="block">
                                {microsite_clt?.registration_name && (
                                    <span
                                        className="inline"
                                        dangerouslySetInnerHTML={{ __html: microsite_clt.registration_name }}
                                    />
                                )}
                                {microsite_clt?.registration_name && microsite_clt?.registration_number && (
                                    <span className="mx-1">|</span>
                                )}
                                {microsite_clt?.registration_number && (
                                    <span
                                        className="inline"
                                        dangerouslySetInnerHTML={{ __html: microsite_clt.registration_number }}
                                    />
                                )}
                            </span>
                        )}
                    </p>
                </div>
            )}
            <div className="px-8 max-sm:px-4 py-3 lg:max-w-7xl mx-auto" style={{ backgroundColor: colors?.primary || '#2167A7' }}>

                <p className='text-left text-white'>
                    {microsite_clt?.privacy_policy && microsite_clt?.privacy_policy !== '' && (
                        <a className='text-white underline' href={microsite_clt?.privacy_policy} target="_blank" rel="noreferrer">Privacy Policy*</a>
                    )}
                    {microsite_clt?.terms_and_condition && microsite_clt?.terms_and_condition !== '' && (
                    <>
                        {microsite_clt?.privacy_policy && microsite_clt?.privacy_policy !== '' && (
                        <span className='text-white mx-2'>|</span>
                        )}
                        <a className='text-white underline' href={microsite_clt?.terms_and_condition} target="_blank" rel="noreferrer">Terms & Conditions*</a>
                    </>
                    )}
                    
                </p>
            </div>
            { (microsite_clt?.custom_disclamer ||  microsite_clt?.custom_note) && (
                <div className="px-8 max-sm:px-4 py-3 lg:max-w-7xl mx-auto" style={{ backgroundColor: colors?.primary || '#2167A7', borderTop: `2px solid #ffffff` }}>
                    <div className="text-white">
                        { microsite_clt?.custom_disclamer && (
                            <div 
                                className="text-sm max-sm:text-xs not-italic font-normal leading-6 opacity-90 text-left"
                                style={{ color: '#ffffff' }}
                                dangerouslySetInnerHTML={{ __html: `<strong>Disclaimer :</strong> ${disclaimerText}` }}
                            />
                        )}
                        { microsite_clt?.custom_note && (
                            <div 
                                className="text-sm max-sm:text-xs not-italic font-normal leading-6 opacity-90 text-left"
                                style={{ color: '#ffffff' }}
                                dangerouslySetInnerHTML={{ __html: `<strong>Note :</strong> ${customNoteText}` }}
                            />
                        )}
                    </div>
                </div>
            )}
            
        </>
    );
};

export default Disclaimer;